// Shared "DM this member" affordance used across the group surfaces (Circle
// and Network leader pages, the members rails + edit modals, and the admin
// Pending-requests card). Wraps the `useFindOrCreateDirectConversation`
// mutation (find-or-create the 1:1 conversation, then navigate). Surfaces
// failure messages so call sites can render them in their own aria-live
// region.

import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';

import type { UserId } from '@leanin/shared/ids';
import { useFindOrCreateDirectConversation } from '../../lib/mutations/messaging';
import { messagesHref } from '../../routes/_authed/messages/index';

export type UseMessageMember = {
  readonly isPending: boolean;
  readonly error: string | null;
  readonly messageMember: (userId: string) => void;
};

export function useMessageMember(): UseMessageMember {
  const navigate = useNavigate();
  const mutation = useFindOrCreateDirectConversation();
  const [error, setError] = useState<string | null>(null);
  const messageMember = (userId: string) => {
    setError(null);
    mutation.mutate(userId as UserId, {
      onSuccess: (result) => {
        navigate({ to: messagesHref({ conversationId: result.conversationId }) });
      },
      onError: (err) => {
        setError(err instanceof Error ? err.message : 'Could not start conversation');
      },
    });
  };
  return { isPending: mutation.isPending, error, messageMember };
}
